module.exports = __webpack_public_path__ + "img/107063.c165a62d.png";